// This file is used to set up the JS routing, do not add any JS code here other than to create a new route. For Global JS use common.js. 
// For template type specific JS you can import a file here using kebob case. EX: a post type archive page body class of 'post-type-archive-az_resources' would be 
// named and imported as postTypeArchiveAz_resources.js: import postTypeArchiveAzResources from './routes/postTypeArchiveAz_resources';


// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function() {
  if (typeof window.CustomEvent === 'function') return false

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

// import external dependencies
import 'jquery';
import 'slick-carousel';

// Import everything from autoload
import './autoload/_foundation.js'; import './autoload/Modal.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(document).ready($ => {
  // Event handler for pagination buttons
  // Click event for pagination buttons
  $('.pagination-buttons').on('click', '.load-more-button', function () {
    const targetPage = parseInt($(this).data('page'));
    performSearchAndPagination(targetPage);
  });

  // Event handler for team member search and pagination
  function performSearchAndPagination(targetPage = 1, isFirstCall = false) {
    $('.team-members').addClass('loading');

    // Get the active button for each filter
    const areasFilter = $('.filter-select[name="sj_justice_areas_filter"] .filter-button').filter('.active').data('term');
    const regionsFilter = $('.filter-select[name="sj_justice_regions_filter"] .filter-button').filter('.active').data('term');

    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        action: 'load_team_members',
        sj_justice_areas_filter: areasFilter,
        sj_justice_regions_filter: regionsFilter,
        paged: targetPage,
      },
      success: function (response) {
        const parsedResponse = JSON.parse(response);

        // Replace existing content with new team members
        $('.team-members').html(parsedResponse.html);
        // Update pagination buttons outside the .team-members div
        $('.pagination-buttons').html(parsedResponse.pagination);

        // Remove the loading class once the AJAX request is complete
        $('.team-members').removeClass('loading');

        // if (!isFirstCall) {
        //   $('html, body').animate({
        //     scrollTop: $('.team-member-filters').offset().top,
        //   }, 1000);
        // }
      },
      error: function (errorThrown) {
        console.log(errorThrown);
      },
    });
  }

  // Event handler for Enter key in search field
  $('input[name="search_filter"]').on('keypress', function (e) {
    if (e.which === 13) {
      performSearchAndPagination(1);
    }
  });

  // Event handler for button click on filter buttons
  $('.filter-select .filter-button').on('click', function () {
    // Toggle the active class
    $('.show-all-button').removeClass('active');
    $(this).parent().children('button').removeClass('active');
    $(this).parent().siblings().children('button').removeClass('active');
    $(this).toggleClass('active');

    // Check if there are any active filter buttons
    const activeFilterButtons = $('.filter-select .filter-button.active');
    if (activeFilterButtons.length === 0) {
      // If no filter buttons are active, add the active class to the Show All button
      $('.show-all-button').addClass('active');
    }
    performSearchAndPagination(1);
  });

  // Event handler for click on show all button
  $('.show-all-button').on('click', function () {
    // Remove active class from all filter buttons
    $('.filter-select .filter-button').removeClass('active');
    $('.show-all-button').addClass('active');
    // Perform search with empty filters
    performSearchAndPagination(1);
  });

  // Event handler for input focus
  $('input[name="search_filter"]').on('focus', function () {
    $('.clear-filter-button').show();
    $(this).addClass('focused');
  });

  // Event handler for clear filter button click
  $('.clear-filter-button').on('click', function () {
    $('input[name="search_filter"]').val('');
    $('input[name="search_filter"]').removeClass('focused');

    // Remove active class from all filter buttons
    $('.filter-select .filter-button').removeClass('active');

    $(this).hide();
    performSearchAndPagination(1);
  });

  performSearchAndPagination(1, true);
});



// WEBPACK FOOTER //
// ./scripts/main.js